var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"v-bar--underline",attrs:{"flat":""}},[_c('v-list-item',{staticClass:"pa-0 mx-n1"},[_c('vuetify-logo',{attrs:{"to":{ name: 'Home' }}}),_c('v-spacer'),_c('releases-menu')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }